import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, Form, Input, Popover, Select, Steps, StepsProps} from "antd";
import Header from "../../components/header/Header";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";
import {CategoryCard, LocationCard} from "../../components";
import {StyledCard} from "../../components/categoryPopup/CategoryPopup.styled";
import {useForm} from "antd/es/form/Form";
import {AdInsertStepOneProps, OnCategoryConfirm} from "../../models";
import TextArea from "antd/es/input/TextArea";
import {useLocation, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {getCities, getProductSubCategoryList, getProvinces, getUserCities} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import cities from "../../../../shared/assets/cities";
import styled from "./AInsertStepone.module.scss";
import subCategoryList from "../../../../shared/assets/subCategoryList";
import style from "../adInsertStepTwo/AInsertStepTow.module.scss";
import {StyledSteps} from "../AdInsertSteps.styled";
import FullScreenTextArea from "./FullScreenTextArea";

const AdInsertStepOne = ({getCities,getProductSubCategoryList}: AdInsertStepOneProps) => {
    let navigate = useNavigate();
    let location = useLocation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [citiesList, setCitiesList] = useState<any[]>([]);

    const onFinish = (value: any) => {
    navigate('/ad-insert-step-two',{state:{
        stepOneForm:value,
        stepTwoForm:location.state?.stepTwoForm,
        }})
    }


    useEffect(() => {
        console.log(location?.state)
        location.state?.stepOneForm && form.setFieldsValue(location.state.stepOneForm);
    }, [location.state]);
    const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
        <Popover
        >
            {dot}
        </Popover>
    );
    return (
        <Flex vertical gap={"small"}>
            <Header step={1}/>
            <BackGroundLogo step={1}/>
               <Form form={form} onFinish={onFinish}>
                   <Flex vertical>
                       <Flex vertical align={"middle"}>
                           <Form.Item  name={'cityId'}
                                       rules={[{ required: true, message: "شهر را وارد کنید" }]}
                           >

                               <Select  showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}

                                        variant={"outlined"} options={cities} size={"large"} placeholder={'شهر'}
                               />
                           </Form.Item>
                           <Form.Item  name={'subCategoryId'}
                                       rules={[{ required: true, message: "دسته بندی را وارد کنید" }]}
                           >

                               <Select
                                   showSearch
                                   optionFilterProp="children"
                                   filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                   options={subCategoryList}  variant={"outlined"}  size={"large"} placeholder={'دسته بندی'}

                               />
                           </Form.Item>
                           <Form.Item  name={'name'}
                                       rules={[{ required: true, message: "عنوان آگهی را وارد کنید" }]}
                           >

                               <Input variant={"outlined"} size={"large"} placeholder={'عنوان آگهی'} />
                           </Form.Item>
 
                            <Form.Item
                            name={'description'}
                            rules={[{ required: true, message: "توضیحات را وارد کنید" }]}
                            >
 
                            <FullScreenTextArea />
                            </Form.Item>


                       </Flex>

                       <Flex gap={"small"} className={styled.customBtns}>
                           <Button  htmlType={"submit"} size={"large"} type={"primary"} block> ادامه</Button>
                           <Button onClick={() => navigate('/')} size={"large"}  block > انصراف</Button>
                       </Flex>
                   </Flex>
               </Form>
        </Flex>
    );
};

export default connect(null, {getCities,getProductSubCategoryList})(withRouter(AdInsertStepOne));
